import { GoogleOAuthProvider } from "@react-oauth/google";
import { store } from "Redux/Store";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from '@posthog/react';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

const options = {
  api_host: "https://us.i.posthog.com",
  defaults: '2026-01-30',
}

root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <PostHogProvider apiKey={process.env.REACT_APP_POST_HOG_API} options={options}>
        <Provider store={store}>
          <GoogleOAuthProvider
            clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}
          >
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </GoogleOAuthProvider>
        </Provider>
      </PostHogProvider>
  </HelmetProvider>
  // </React.StrictMode>
);

reportWebVitals();
